import { defineMessages } from 'react-intl'

const messages = defineMessages({
  mobileOnlyTag: {
    id: 'global.mobile-only-price',
  },
})

export default messages
